// libs
import React, { memo, useContext, useMemo, Fragment } from "react";

// components
import FakeScroller from "shared/components/FakeScroller";

// context
import MenuContext from "shared/components/Header/DesktopHeader/components/Menu/MenuContext";

// defs
import { IAllBrandsProps } from "./types";

// helpers
import { getChannel } from "./helpers";
import { generateTrackingUrlForMegaMenu } from "shared/components/Header/helpers";

// styles
import {
    AllBrandsContainer,
    BrandListContainer,
    BrandTitle,
    BrandItem,
    BrandAnchor,
} from "./styles";

function AllBrands({ availableBrands, selectedCategory }: IAllBrandsProps) {
    const { goToUrl } = useContext(MenuContext);

    const availableInitials = useMemo(() => {
        return Object.keys(availableBrands).sort();
    }, [availableBrands]);

    let position = 0;

    return (
        <AllBrandsContainer>
            <FakeScroller>
                <div className="br-inner">
                    <BrandListContainer>
                        {availableInitials.map((character, idx) => {
                            return (
                                <Fragment key={`key-${character}-${idx}`}>
                                    <BrandTitle>{character}</BrandTitle>

                                    {availableBrands[character].map(brand => {
                                        ++position;

                                        brand = {
                                            ...brand,
                                            channel: getChannel({
                                                channel: brand.channel,
                                                selectedCategory,
                                            }),
                                            position,
                                            level: 3,
                                        };
                                        const onClick = (e: React.MouseEvent) => {
                                            e.preventDefault();
                                            goToUrl(brand);
                                        };

                                        return (
                                            <BrandItem key={brand.id}>
                                                <BrandAnchor
                                                    href={generateTrackingUrlForMegaMenu(brand)}
                                                    onClick={onClick}
                                                >
                                                    {brand.title}
                                                </BrandAnchor>
                                            </BrandItem>
                                        );
                                    })}
                                </Fragment>
                            );
                        })}
                    </BrandListContainer>
                </div>
            </FakeScroller>
        </AllBrandsContainer>
    );
}

export default memo(AllBrands);
